import { CommonImages } from '../../theme/CommonImages'

export type FoxImageProps = {} & React.ImgHTMLAttributes<HTMLImageElement>

export const FoxImage = ({ src, ...rest }: FoxImageProps) => {
    // TODO use caching image component
    return <img {...rest} src={src ?? CommonImages.general.foxtailLogo} />
}
